






































import { mapGetters } from 'vuex';
import { DateTime } from 'luxon';

import VExtendedDataPicker from '@/components/VExtendedDataPicker.vue';

import FeatureFlagRedirectMixin from '@/mixins/copy-stake/FeatureFlagRedirectMixin';

import {
  getCopyStakeReport,
  getCopyStakeReportPdf
} from '@/api/CopyStake/Providers';

import { doDownload } from '@/helpers/download';

const defaultOptions = {
  page: 1,
  itemsPerPage: 10
};
const MAX_DATE = DateTime.now().minus({ month: 1 }).toFormat('yyyy-MM-dd');

export default {
  name: 'CopyStakeGameProvidersView',
  components: { VExtendedDataPicker },
  mixins: [FeatureFlagRedirectMixin],
  data(): any {
    return {
      MAX_DATE,
      isLoading: false,
      date: MAX_DATE,
      total: null,
      list: [],
      options: { ...defaultOptions }
    };
  },
  computed: {
    ...mapGetters('Onboarding', ['operatorId']),
    headers(): { [key: string]: string }[] {
      return [
        { text: 'Name', value: 'provider', width: '30%' },
        { text: 'GGR', value: 'ggr', width: '30%' },
        { text: 'Report', value: 'report', width: '30%' }
      ];
    },
    formattedDate(): string {
      return DateTime.fromISO(this.date).toFormat('yyyy-MM-dd');
    }
  },
  watch: {
    operatorId(): void {
      this.getCopyStakeList();
    }
  },
  methods: {
    getCopyStakeList(): void {
      if (!this.operatorId) return;

      this.isLoading = true;

      getCopyStakeReport({
        date: this.formattedDate,
        size: this.options.itemsPerPage,
        page: this.options.page - 1
      })
        .then((response) => {
          this.list = response.content;
          this.total = response.totalElements;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    getCopyStakeReportPdf(provider: string): void {
      getCopyStakeReportPdf({
        date: this.formattedDate,
        provider
      }).then((res) => {
        const fileName = `${provider.toLowerCase()}_${this.formattedDate}`;

        const url = window.URL.createObjectURL(
          new Blob([res.data], {
            type: 'application/pdf'
          })
        );
        doDownload(url, `${fileName}.pdf`);
      });
    }
  }
};
